import * as monacoEditor from "monaco-editor";
import { colors } from "@apollo/space-kit/colors";

// this is a copy of the theme from studio
// https://github.com/mdg-private/studio-ui/blob/main/src/components/editor/studioThemeEditableDark.ts

export const STUDIO_THEME_EDITABLE_DARK = "studio-editable-dark";
export const studioThemeEditableDark: monacoEditor.editor.IStandaloneThemeData =
  {
    base: "vs-dark",
    inherit: true,
    colors: {
      /**
       * (from dman)
       *
       * Please don't kill me 🙏The `editor.background` option ONLY accepts a hex
       * code, and we want transparent. If you don't specify a hex, you get...
       * RED (why is this the default?!). So here we use #ffffff (a safe default),
       * and tack on 00 to represent 0-alpha, i.e. completely transparent.
       *
       * Reference: https://stackoverflow.com/questions/23201134/transparent-argb-hex-value
       */
      // full index available at https://code.visualstudio.com/api/references/theme-color
      "editor.background": "#ffffff00",
      "editorLineNumber.foreground": colors.midnight.light,
      "editorIndentGuide.background": colors.midnight.dark,
      "editorIndentGuide.activeBackground": colors.midnight.light,
      // suggestion popover
      "editorWidget.background": colors.midnight.darkest,
      "editorWidget.foreground": colors.midnight.lightest,
      "editorWidget.border": colors.midnight.base,
      // context menu
      "menu.background": colors.midnight.darkest,
      "menu.foreground": colors.white,
      "menu.selectionBackground": colors.midnight.base,
      "menu.selectionForeground": colors.white,
    },
    // rules have specificity that's kind of similar to css
    // more matching segments results in higher specificity
    rules: [
      {
        token: "punctuation",
        foreground: colors.silver.dark.replace(/^#/, ""),
      },

      // graphql colors
      {
        token: "comment",
        foreground: colors.midnight.lighter.replace(/^#/, ""),
      },

      // operation type (this includes keyword.query, keyword.mutation, keyword.subscription)
      { token: "keyword", foreground: colors.blilet.light.replace(/^#/, "") },

      // operation name
      { token: "def", foreground: colors.teal.base.replace(/^#/, "") },

      // argument name declaration
      { token: "variable", foreground: colors.orange.light.replace(/^#/, "") },
      // argument type, fragment parent type
      {
        token: "atom.namedtype",
        foreground: colors.teal.base.replace(/^#/, ""),
      },

      // argument name
      {
        token: "attribute.argument",
        foreground: colors.blilet.lighter.replace(/^#/, ""),
      },

      // field name
      {
        token: "property",
        foreground: colors.blilet.lighter.replace(/^#/, ""),
      },

      // literal argument values
      {
        token: "builtin.booleanvalue",
        foreground: colors.orange.light.replace(/^#/, ""),
      },
      { token: "string", foreground: colors.orange.light.replace(/^#/, "") },
      { token: "number", foreground: colors.orange.light.replace(/^#/, "") },

      // JSON colors
      {
        token: "string.key.json",
        foreground: colors.blilet.lighter.replace(/^#/, ""),
      },
      {
        token: "string.value.json",
        foreground: colors.orange.light.replace(/^#/, ""),
      },
      {
        token: "keyword.json",
        foreground: colors.orange.light.replace(/^#/, ""),
      },
      {
        token: "number.json",
        foreground: colors.orange.light.replace(/^#/, ""),
      },
      {
        token: "delimiter.bracket.json",
        foreground: colors.silver.dark.replace(/^#/, ""),
      },
      {
        token: "delimiter.colon.json",
        foreground: colors.silver.dark.replace(/^#/, ""),
      },
      {
        token: "delimiter.comma.json",
        foreground: colors.silver.dark.replace(/^#/, ""),
      },
    ],
  };
